import * as React from 'react'
import type {SVGProps} from 'react'
const SvgFsaTracker = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width={22}
        height={22}
        viewBox="0 0 22 22"
        {...props}
    >
        <defs>
            <path id="fsa-tracker_svg__a" d="M0 0h22v22H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <mask id="fsa-tracker_svg__b" fill="#fff">
                <use xlinkHref="#fsa-tracker_svg__a" />
            </mask>
            <path
                fill="#182744"
                d="M18 0H4C1.8 0 0 1.8 0 4v14c0 2.2 1.8 4 4 4h14c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4m0 1.5c1.378 0 2.5 1.122 2.5 2.5v14c0 1.379-1.122 2.5-2.5 2.5H4A2.503 2.503 0 0 1 1.5 18V4c0-1.378 1.122-2.5 2.5-2.5z"
                mask="url(#fsa-tracker_svg__b)"
            />
            <path
                stroke="#182744"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M3 11h16M11 3v16"
            />
            <g stroke="#182744" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
                <path d="m13.5 16.5 1.552 2.316M18.866 14.637l-3.814 4.178" />
            </g>
        </g>
    </svg>
)
export default SvgFsaTracker
